import { render, staticRenderFns } from "./CustomWeightsForm.vue?vue&type=template&id=52d54ecc&scoped=true&"
import script from "./CustomWeightsForm.vue?vue&type=script&lang=js&"
export * from "./CustomWeightsForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomWeightsForm.vue?vue&type=style&index=0&id=52d54ecc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d54ecc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VDataTable,VEditDialog,VIcon,VRow,VSnackbar,VTextField,VTooltip})
